import state from './state'
import DTEutils from '@/mixins/DTE'
import { stat } from 'fs'

const SALE_CUSTOMER = 'SC'
const SALE_EMPLOYEE = 'SE'
const totalPaid = function(state, getters) {
    return getters.salePaid
    /*
    let total = 0
    var i
    for (i = 0; i < state.arrayPayments.length; i++) {
        total += parseInt(state.arrayPayments[i].payment)
    }
    return total.toString()
    */
}

const totalSale = function(state, getters) {
    return getters.saleTotal
    /*
    if (state.posSaleType === 1) {
        let response = null
        if (state.arrayPayments != []) {
            response = state.arrayPayments.find(
                element => element.paymentMethod == 1
            )
        }
        return state.payer === SALE_EMPLOYEE &&
            (state.paymentMethod === 1 || response)
            ? //? state.netTotal
              state.total
            : state.total
    } else if (state.posSaleType === 2) {
        return state.totalInvoice
    } else {
        return null
    }
    */
}

const totalToPay = function(state, getters) {
    return getters.saleToPay
    /*
    let response = null
    let substract = 0
    let resto = totalSale() - parseInt(totalPaid())
    if (state.arrayPayments != []) {
        response = state.arrayPayments.find(
            element => element.paymentMethod == 1
        )
    }
    if (response) {
        substract = parseInt(totalPaid()) - response.payment
    }

    if (
        state.paymentMethod === 1 &&
        resto > 9 &&
        state.arrayPayments.length < 1
    ) {
        return rounding(totalSale() - parseInt(totalPaid()))
    } else if (response && resto < 9 && state.arrayPayments.length == 1) {
        return rounding(totalSale() - parseInt(totalPaid()))
    } else {
        return totalSale() - parseInt(totalPaid())
    }
    */
}

const change = function(state, getters) {
    return getters.saleCashChange
    /*
    let response = null
    if (state.arrayPayments != []) {
        response = state.arrayPayments.find(
            element => element.paymentMethod == 1
        )
    }

    let totalPaidNum = parseInt(totalPaid())
    let totalToPayNum = totalSale()

    if (response && state.arrayPayments.length == 1) {
        totalToPayNum = rounding(totalSale())
    }

    if (totalPaidNum < totalToPayNum) {
        return ''
    } else {
        let changeNum = totalPaidNum - totalToPayNum
        return changeNum.toString()
    }
    */
}

/**
 * Returns true if al data necesary for confirming sale is set, false if any data is missing.
 */
const allDataSet = function() {
    if (parseInt(state.payment) === 0) {
        return false
    }
    if (state.paymentMethod === 1) {
        // Cash payment:
        return state.payment != ''
    } else {
        // Other payment methods:
        return state.payment != '' && state.paymentDetail != null
    }
}

const subTotal = function() {
    let sub = 0
    if (state.saleDetail != null) {
        if (
            state.payer == SALE_EMPLOYEE &&
            (state.paymentMethod === 1 || state.paymentMethod === null)
        ) {
            state.saleDetail.map(detail => {
                sub += detail.total
                //sub += detail.new_net_subtotal
            })
        } else {
            state.saleDetail.map(detail => {
                sub += detail.total
            })
        }
    }
    return sub
}

const amountDiscount = function(state, getters) {
    return DTEutils.percentage(
        parseInt(state.discountOrChargePercentage),
        parseInt(getters.subTotal)
    )
}

const roundingLaw = function(state, getters) {
    return getters.saleRoundingLaw
    //return rounding(totalSale()) - totalSale()
}

// FIXED CALCS
const saleTotal = state =>
    state.posSaleType === 2 ? state.totalInvoice : state.total

const salePaid = state =>
    state.arrayPayments && state.arrayPayments.length
        ? state.arrayPayments.reduce(
              (paid, item) => (paid += parseInt(item.payment)),
              0
          )
        : 0

const saleToPay = (state, getters) => {
    if (
        state.arrayPayments.some(p => p.paymentMethod === 1) &&
        getters.saleTotal - getters.salePaid < 10
    )
        return 0
    return getters.saleTotal - getters.salePaid
}

const saleCashPayment = (state, getters) =>
    state.arrayPayments && state.arrayPayments.length
        ? state.arrayPayments.find(
              (p, idx) =>
                  p.paymentMethod === 1 &&
                  ((state.arrayPayments.length === 1 &&
                      getters.totalToPay <= 0) ||
                      idx !== 0)
          )
        : null

const saleCashPaymentAmount = (state, getters) =>
    getters.saleCashPayment ? parseInt(getters.saleCashPayment.payment) : null

const saleOtherPayments = state =>
    state.arrayPayments && state.arrayPayments.length
        ? state.arrayPayments.filter(p => p.paymentMethod !== 1)
        : null

const saleOtherPaymentsAmount = (state, getters) =>
    getters.saleOtherPayments
        ? getters.saleOtherPayments.reduce(
              (paid, item) => (paid += parseInt(item.payment)),
              0
          )
        : null

const saleRoundingLaw = (state, getters) => {
    if (state.paymentMethod === 1)
        return rounding(getters.saleToPay) - getters.saleToPay
    if (getters.saleCashPaymentAmount) {
        let diff = getters.saleTotal - getters.saleOtherPaymentsAmount
        return rounding(diff) - diff
    }
    return 0
}

const showingTotalSale = (state, getters) =>
    getters.totalSale + getters.roundingLaw

const saleFinalToPay = (state, getters) =>
    getters.saleTotal - getters.salePaid + getters.saleRoundingLaw

// const saleCashChange = (state, getters) => Math.abs(getters.saleFinalToPay)
const saleCashChange = (state, getters) => {
    if (getters.saleFinalToPay <= 0)
        return getters.totalPaid - getters.showingTotalSale
    else return 0
}

const rounding = function(amount) {
    let resto = amount % 10
    if (resto < 6) {
        return amount - resto
    }
    return amount + 10 - resto
}

const currentLines = function() {
    return state.saleDetail ? state.saleDetail.length : 0
}
/*
 */
const currentDiscountOrChargePercentage = function() {
    return state.discountOrChargePercentage
}
/*
 */
const currentIdMultiTicket = function() {
    if (state.multipleSaleTicket.length > 0) {
        return state.multipleSaleTicket.map(r => {
            return r.id
        })
    } else {
        return []
    }
}

const requireExtraCreditAuth = (state, getters, rootState, rootGetters) => {
    if (!rootGetters['CustomerModule/activeCustomerCredit']) return false
    let creditPayment = state.arrayPayments.find(p => p.paymentMethod === 5)
    if (!creditPayment) return false
    if (
        creditPayment &&
        parseInt(creditPayment.payment) >
            rootGetters['CustomerModule/activeCustomerCredit']
                .available_customer_credit
    )
        return true
    return false
}

const activePchPaymentCondition = (state, getters, rootState) => {
    let payment = state.arrayPayments.find(p => p.paymentMethod === 5)
    if (!payment || !payment.paymentDetail) return null
    return rootState.SessionModule.pchPaymentConditions.find(
        cond => cond.id === payment.paymentDetail.id
    )
}

const requireExtraCreditOptionAuth = (
    state,
    getters,
    rootState,
    rootGetters
) => {
    if (!getters.activePchPaymentCondition) return
    let defCond =
        rootGetters['CustomerModule/defaultCustomerPchPaymentCondition']
    if (!defCond) return false
    if (defCond.days < getters.activePchPaymentCondition.days)
        return {
            requireAuth: true,
            text:
                `Plazo de crédito cliente seleccionado (${
                    getters.activePchPaymentCondition.days
                } días)` +
                ` excede el máximo permitido para este cliente (${
                    defCond.days
                } días) `,
        }
    else return null
}

export default {
    change,
    totalToPay,
    allDataSet,
    totalPaid,
    totalSale,
    subTotal,
    amountDiscount,
    roundingLaw,
    currentLines,
    currentDiscountOrChargePercentage,
    currentIdMultiTicket,
    salePaid,
    saleTotal,
    saleToPay,
    saleRoundingLaw,
    saleFinalToPay,
    saleCashPayment,
    saleCashPaymentAmount,
    saleOtherPayments,
    saleOtherPaymentsAmount,
    saleCashChange,
    requireExtraCreditAuth,
    activePchPaymentCondition,
    requireExtraCreditOptionAuth,
    showingTotalSale,

    /**
     * 
     */
    saleDetail: state => state.saleDetail,

    /**
     * 
     */
    salePayments: state => state.arrayPayments,
}
